'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.BridgeType = void 0;
(function (BridgeType) {
    BridgeType["NAVIGATE_TO_SCREEN"] = "navigateToScreen";
    BridgeType["CLOSE_WEBVIEW"] = "close";
})(exports.BridgeType || (exports.BridgeType = {}));
exports.IDimensionType = void 0;
(function (IDimensionType) {
    IDimensionType["TYPE_INVALID"] = "TYPE_INVALID";
    IDimensionType["TYPE_RELATIVE"] = "TYPE_RELATIVE";
    IDimensionType["TYPE_ABSOLUTE"] = "TYPE_ABSOLUTE";
})(exports.IDimensionType || (exports.IDimensionType = {}));
exports.IRelativeDimensionReference = void 0;
(function (IRelativeDimensionReference) {
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_INVALID"] = "RELATIVE_DIMENSION_REFERENCE_INVALID";
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"] = "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH";
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_DEVICE_HEIGHT"] = "RELATIVE_DIMENSION_REFERENCE_DEVICE_HEIGHT";
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_WIDTH"] = "RELATIVE_DIMENSION_REFERENCE_WIDTH";
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_HEIGHT"] = "RELATIVE_DIMENSION_REFERENCE_HEIGHT";
    IRelativeDimensionReference["RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"] = "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH";
})(exports.IRelativeDimensionReference || (exports.IRelativeDimensionReference = {}));
exports.ActionTypes = void 0;
(function (ActionTypes) {
    ActionTypes["NATIVE_BRIDGE"] = "NATIVE_BRIDGE";
})(exports.ActionTypes || (exports.ActionTypes = {}));
//# sourceMappingURL=type.js.map
